export default "__VITE_ASSET__DdGK5JIa__"